<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>
      {{'Novo' | translate}} {{ validations_form.get('tipo')?.value == 0 ? ('Acompanhamento' | translate) :
      ('Compromisso' | translate) }}
    </ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form [formGroup]="validations_form">
    <div class="gradient-extendido"></div>

    <ion-card-content>
      <ng-container *ngIf="!acompanhamento || !acompanhamento.id">
        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label label-placement="stacked" [class.disabled-label]="validations_form.get('tipo')?.disabled">
              {{'Tipo' | translate}} <span class="danger">*</span>
            </ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Tipo' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="tipo"
              (ionChange)="tipoChange($event)"
            >
              <ion-select-option *ngFor="let tipo of tipoList" [value]="tipo.id">{{tipo.nome}}</ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.tipo">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('tipo')?.hasError(validation.type) && (validations_form.get('tipo')?.dirty || validations_form.get('tipo')?.touched)"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>
      </ng-container>

      <ng-container *ngIf="validations_form.get('tipo')?.value == '1'">
        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label label-placement="stacked" [class.disabled-label]="validations_form.get('titulo')?.disabled">
              {{'Título' | translate}}
              <span class="danger">*</span>
            </ion-label>
            <ion-textarea placeholder="{{'Título' | translate}}" rows="1" formControlName="titulo"> </ion-textarea>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.titulo">
                <div class="error-message" *ngIf="submitted && validations_form.get('titulo')?.invalid">
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>
      </ng-container>

      <ng-container *ngIf="validations_form.get('tipo')?.value == '0'">
        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label label-placement="stacked" [class.disabled-label]="validations_form.get('idCategoria')?.disabled">
              {{'Categoria' | translate}} <span class="danger">*</span>
            </ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Categoria' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idCategoria"
              (ionChange)="changeAcao($event)"
            >
              <ion-select-option *ngFor="let categoria of categoriaList" [value]="categoria.id"
                >{{categoria.titulo}}</ion-select-option
              >
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.idCategoria">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('idCategoria')?.hasError(validation.type) && submitted"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label
              label-placement="stacked"
              [class.disabled-label]="validations_form.get('idAcompanhamentoOperacao')?.disabled"
            >
              {{'Ação' | translate}} <span class="danger">*</span>
            </ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Ação' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idAcompanhamentoOperacao"
            >
              <ion-select-option *ngFor="let acao of acaoList" [value]="acao.id">{{acao.nome}}</ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.idAcompanhamentoOperacao">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('idAcompanhamentoOperacao')?.hasError(validation.type) && submitted"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label
              label-placement="stacked"
              [class.disabled-label]="validations_form.get('idAcompanhamentoStatus')?.disabled"
            >
              {{'Status' | translate}} <span class="danger">*</span>
            </ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Status' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idAcompanhamentoStatus"
            >
              <ion-select-option *ngFor="let status of statusList" [value]="status.id">
                {{status.nome}}
              </ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.idAcompanhamentoStatus">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('idAcompanhamentoStatus')?.hasError(validation.type) && submitted"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>

        <ion-row class="border-bottom">
          <ion-col size="12" class="ion-margin-horizontal">
            <ion-label label-placement="stacked" [class.disabled-label]="validations_form.get('restrito')?.disabled">
              {{'Acompanhamento Público?' | translate}} <span class="danger">*</span>
            </ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="{{'Acompanhamento Público?' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="restrito"
            >
              <ion-select-option *ngFor="let list of simNaoList" [value]="list.id">{{list.nome}}</ion-select-option>
            </ion-select>

            <div class="validation-errors">
              <ng-container *ngFor="let validation of validation_messages.restrito">
                <div
                  class="error-message"
                  *ngIf="validations_form.get('restrito')?.hasError(validation.type) && submitted"
                >
                  {{ validation.message }}
                </div>
              </ng-container>
            </div>
          </ion-col>
        </ion-row>
      </ng-container>

      <ng-container>
        <div class="border-bottom">
          <prover-datepicker
            [labelName]="'Data Início'"
            [id]="'dataHora_data'"
            formControlName="dataHora_data"
            [required]="true"
            [disabled]="validations_form.get('dataHora_data')?.disabled ?? false"
          ></prover-datepicker>

          <div class="validation-errors ion-margin-start">
            <ng-container *ngFor="let validation of validation_messages.dataHora_data">
              <div
                class="error-message"
                *ngIf="validations_form.get('dataHora_data')?.hasError(validation.type) && (validations_form.get('dataHora_data')?.dirty || validations_form.get('dataHora_data')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="border-bottom">
          <app-prover-horas
            [labelName]="'Hora Início'"
            [id]="'dataHora_hora'"
            formControlName="dataHora_hora"
            [required]="true"
            [isLabel]="true"
            [disabled]="validations_form.get('dataHora_hora')?.disabled ?? false"
          ></app-prover-horas>
        </div>
        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.dataHora_hora">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHora_hora')?.hasError(validation.type) && (validations_form.get('dataHora_hora')?.dirty || validations_form.get('dataHora_hora')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container>
        <div class="border-bottom">
          <prover-datepicker
            [labelName]="'Data Fim'"
            [id]="'dataHoraFim_data'"
            formControlName="dataHoraFim_data"
            [required]="true"
            [disabled]="validations_form.get('dataHoraFim_data')?.disabled ?? false"
          ></prover-datepicker>

          <div class="validation-errors ion-margin-start">
            <ng-container *ngFor="let validation of validation_messages.dataHoraFim_data">
              <div
                class="error-message"
                *ngIf="validations_form.get('dataHoraFim_data')?.hasError(validation.type) && (validations_form.get('dataHoraFim_data')?.dirty || validations_form.get('dataHoraFim_data')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-container>
        <div class="border-bottom">
          <app-prover-horas
            [labelName]="'Hora Fim'"
            [id]="'dataHoraFim_hora'"
            formControlName="dataHoraFim_hora"
            [required]="true"
            [isLabel]="true"
            [disabled]="validations_form.get('dataHoraFim_hora')?.disabled ?? false"
          ></app-prover-horas>
        </div>
        <div class="validation-errors ion-margin-start">
          <ng-container *ngFor="let validation of validation_messages.dataHoraFim_hora">
            <div
              class="error-message"
              *ngIf="validations_form.get('dataHoraFim_hora')?.hasError(validation.type) && (validations_form.get('dataHoraFim_hora')?.dirty || validations_form.get('dataHoraFim_hora')?.touched)"
            >
              {{ validation.message }}
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ion-row class="border-bottom">
        <ion-col size="12" class="ion-margin-horizontal">
          <ion-label label-placement="stacked" [class.disabled-label]="validations_form.get('descricao')?.disabled">
            {{'Descrição' | translate}} <span class="danger">*</span>
          </ion-label>
          <ion-textarea
            placeholder="{{'Descrição' | translate}}"
            rows="2"
            cols="60"
            formControlName="descricao"
          ></ion-textarea>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.descricao">
              <div
                class="error-message"
                *ngIf="submitted && validations_form.get('descricao')?.hasError(validation.type)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </form>

  <ion-grid>
    <ion-row class="ion-padding-end ion-justify-content-end">
      <ion-col size="5">
        <ion-button
          expand="block"
          class="btn-default btn-text"
          *ngIf="validations_form.get('tipo')?.value == '0' && !acompanhamento"
          (click)="proximo()"
        >
          {{'Próximo' | translate}}
          <i class="fa-solid fa-arrow-right"></i>
        </ion-button>

        <ion-button
          expand="block"
          class="btn-default btn-text"
          *ngIf="validations_form.get('tipo')?.value == '0' && acompanhamento && isAcompanhamento"
          (click)="salvarSubsequente()"
        >
          {{'Próximo' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
      <ion-col size="11">
        <ion-button
          expand="block"
          class="btn-default"
          *ngIf="validations_form.get('tipo')?.value == '0' && acompanhamento && !isAcompanhamento"
          (click)="salvar()"
        >
          {{'Salvar' | translate}}
        </ion-button>

        <ion-button
          expand="block"
          class="btn-default"
          *ngIf="validations_form.get('tipo')?.value == '1'"
          (click)="salvarCompromisso()"
        >
          {{'Salvar' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
